import { createContext } from 'react';
import { ITypographyVariants, ITypographyWeights } from '../Typography';
export const PaginationContext = /*#__PURE__*/createContext({
  onClick: () => {},
  activePageNumber: 1,
  typographyVariant: 'p4',
  typographyWeight: 'default',
  fontSize: '12px'
});